
import api from "../services/api";

// Fetch Agent Support Tickets
export const fetchAgentsSupportTickets = async (
    page = 1,
    size = 10
) => {
    try {
        const response = await api.get(
            "/support-ticket/agent",
            {
                params: { page, size },
            }
        );

        if (
            response.status === 200 &&
            response.data.success
        ) {
            return {
                success: true,
                data: response.data.data,
            };
        }

        return {
            success: false,
            error: "Unexpected response from server",
        };
    } catch (error) {
        console.error(
            "Error fetching Agent Support Tickets:",
            error.message || error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.message ||
                "Failed to fetch Agent Support Tickets",
        };
    }
};

// Update Agent Support Ticket
export const updateAgentSupportTicket = async (
    ticketId,
    payload
) => {
    try {
        const response = await api.put(
            `/support-ticket/ticket/${ticketId}`,
            payload
        );

        if (
            response.status === 200 &&
            response.data.success
        ) {
            return {
                success: true,
                data: response.data.data,
            };
        }

        return {
            success: false,
            error: "Unexpected response from server",
        };
    } catch (error) {
        console.error(
            "Error updating Agent Support Ticket:",
            error.message || error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.message ||
                "Failed to update Agent Support Ticket",
        };
    }
};
